import { z } from "zod";
import {
  assetsGroupGoogleBaseSchema,
  validateAssetsGroupGoogle,
} from "./assetsGroupGoogleSchema";
import {
  assetsGroupLinkedinBaseSchema,
  validateAssetsGroupLinkedin,
} from "./assetsGroupLinkedinSchema";
import { GOOGLE, LINKEDIN } from "../../../../../utils/constants";

const assetsGroupBaseSchema = z.discriminatedUnion("platform", [
  assetsGroupGoogleBaseSchema,
  assetsGroupLinkedinBaseSchema,
]);

export const assetsGroupSchema = ({ campaign, integrations, assetsGroupID }) =>
  assetsGroupBaseSchema.superRefine((data, ctx) => {
    if (data.platform === GOOGLE) {
      validateAssetsGroupGoogle({
        assetsGroup: data,
        ctx,
        campaign,
        integrations,
        assetsGroupID,
      });
    } else if (data.platform === LINKEDIN) {
      validateAssetsGroupLinkedin({
        assetsGroup: data,
        ctx,
        campaign,
        integrations,
        assetsGroupID,
      });
    }
  });
